// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_or-5";
export var filledCircle = "_or-4";
export var historyEntry = "_or-3";
export var messageSideLeft = "_or-1";
export var messageSideRight = "_or-2";
export var orderTrackingCarouselWrapper = "_or-6";
export var orderTrackingInfoContainer = "_or-0";